import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceProtocol } from '../modelinterfaces/device-protocol.model';
import { EnvironmentHelper } from './environment-helper';

@Injectable({
  providedIn: 'root'
})

export class DeviceProtocolService {

  constructor(private http: HttpClient, private environmentHelper: EnvironmentHelper) {
  }

  public getList(): Observable<DeviceProtocol[]> {
    const url = `${this.environmentHelper.urlV2}/deviceProtocol`;
    return this.http.get<DeviceProtocol[]>(url).pipe(
      map(list => DeviceProtocol.valuesOf(list))
    );
  }
}
